export enum EmbeddedProviderQueryParam {
  Cid = 'cid',
  EmbeddedComponentStyles = 'embeddedComponentStyles',
  Language = 'language',
  IsFramed = 'isFramed',
  UsePaymentClient = 'usePaymentClient',
  PaymentSessionId = 'paymentSessionId',
  HostActionId = 'hostActionId',
  HostOrigin = 'hostOrigin',
  PollingStatusUrl = 'pollingStatusUrl',
  RedirectResult = 'redirectResult',
  SessionId = 'sessionId',
  AdyenSessionId = 'adyenSessionId',
  AdyenSessionData = 'adyenSessionData',
  AdyenEnvironment = 'adyenEnvironment',
  RedirectHeight = 'redirectHeight',
  RedirectResizeDelayMs = 'redirectResizeDelayMs',
}

/**
 * Retained as the default for the legacy redirectHeight query parameter.
 * Same-iframe redirects no longer post a synthetic pre-navigation resize.
 */
export const DEFAULT_REDIRECT_HEIGHT = 1600;

/**
 * Gives the host time to apply
 * the redirecting screen before the provider navigation begins.
 */
export const DEFAULT_REDIRECT_RESIZE_DELAY_MS = 600;

/** Max time (ms) to wait for a terminal redirect result relayed through the bridge. */
export const DEFAULT_REDIRECT_RESULT_TIMEOUT_MS = 30000;

/** Interval (ms) used to detect when the shopper closes an external redirect window. */
export const REDIRECT_WINDOW_POLL_INTERVAL_MS = 500;
